import styled from '@emotion/styled';

import { maxWidthAndCenter } from '@styles';

const SplitContainer = styled.div`
  padding: 5rem 0;
  background-image: url('/images/brisbane-local-marketing-a.jpg');
  background-size: 50%;
  background-clip: content-box;
  background-repeat: no-repeat;
  background-position-y: 50%;

  &.split_content--left {
    background-position-x: 0%;
  }

  &.split_content--right {
    background-position-x: 100%;
  }

  .split_content__row {
    ${maxWidthAndCenter}
    display: flex;
  }

  .split_content__mobile_image {
    display: none;
    visibility: hidden;
  }

  .split_content__children {
    padding: 0 5rem 0 0;
    max-width: 50%;

    h2 {
      font-size: 3rem;
      font-weight: 900;
      color: var(--blue);
    }

    hr {
      border-top-width: 0px;
      border-bottom-width: 4px;
      border-color: var(--orange);
      margin: 1.5rem 0;
      max-width: 25%;
    }

    ul {
      margin: 0;
      padding: 0 0 0 1rem;
    }

    li {
      margin: 0 0 1rem 0;
      font-size: 1.25rem;
      font-weight: 700;
      color: var(--blue);

      .bold {
        display: block;
        font-size: 1rem;
      }

      .text {
        display: block;
        font-size: 1rem;
        font-weight: 400;
        color: rgb(0, 0, 0);
      }

      a:not([class*='calls_to_action']) {
        font-weight: 700;
        color: var(--orange);

        :visited {
          color: var(--orange);
        }

        :hover {
          text-decoration: none;
        }
      }
    }

    p {
      margin: 0 0 1.25rem;
    }
  }

  .split_content__children--left {
  }

  .split_content__children--right {
    padding: 0 0 0 5rem;
    margin: 0 0 0 50%;
  }

  @media screen and (max-width: 1500px) {
    .split_content__children--left {
      padding: 0 3rem 0 2rem;
    }

    .split_content__children--right {
      padding: 0 2rem 0 3rem;
    }
  }

  @media screen and (max-width: 1312px) {
    background-image: none;

    .split_content__mobile_image {
      display: block;
      visibility: visible;
      max-width: 50%;
    }

    &.split_content--right .split_content__row {
      flex-direction: row-reverse;
    }

    .split_content__children--right {
      margin: 0;
    }
  }

  @media screen and (max-width: 1024px) {
    padding: 4rem 0 2rem;

    &.split_content--left .split_content__row,
    &.split_content--right .split_content__row {
      flex-direction: column;
    }

    .split_content__mobile_image {
      max-width: 100%;
      margin: 0 2rem 2rem;
    }

    .split_content__children--right {
      padding: 0 4rem 0 2rem;
    }

    .split_content__children {
      padding: 0 2rem;

      h2 {
        font-size: 2rem;
      }

      .calls_to_action {
        padding: 1.5rem 0 0 0;
      }
    }

    .split_content__children--right,
    .split_content__children--left {
      max-width: 100%;
      margin: 0;
    }
  }
`;

export { SplitContainer };
